module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanweiBind',
        'query': {}
      }),
      expression: "{name:'CertDanweiBind','query':{ }}"
    }],
    attrs: {
      "title": "已有单位绑定",
      "label": "单位已在CCA官网备案，请输入原系统账号密码绑定。"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("去绑定")])]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CertDanweiApply',
        'query': {
          new: _vm.$route.query.new
        }
      }),
      expression: "{name:'CertDanweiApply','query':{ new:$route.query.new }}"
    }],
    attrs: {
      "title": "新增单位备案",
      "label": "单位还尚未在CCA官网备案，请提交单位信息备案"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("备案")])]
      },
      proxy: true
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fef9bf7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/cert/CertDanwei.vue
// module id = 2651
// module chunks = 0